import React from "react";
import PropTypes from "prop-types";
import {
  CTAContainer,
  ContentWrapper, // New wrapper to contain content for max-width
  Title,
  SubTitle,
  PrimaryButton,
  SecondaryLinkText,
  SecondaryLink,
} from "./PublicAccessCTA.styles";

const PublicAccessCTA = ({ visible = false, onSignup, onSignin }) => {
  if (!visible) return null;

  return (
    <CTAContainer role="dialog" aria-live="polite">
      <ContentWrapper>
        <Title>
          Join Surmount to view insights and invest in this strategy
        </Title>
        <SubTitle>
          Sign up to access dozens of investment strategies on Surmount.
        </SubTitle>
        {/* We place the button and link directly without a separate Actions div */}
        <PrimaryButton onClick={onSignup}>Sign up</PrimaryButton>
        <SecondaryLinkText>
          Already have an account?{" "}
          <SecondaryLink onClick={onSignin}>Sign in</SecondaryLink>
        </SecondaryLinkText>
      </ContentWrapper>
    </CTAContainer>
  );
};

PublicAccessCTA.propTypes = {
  visible: PropTypes.bool,
  onSignup: PropTypes.func,
  onSignin: PropTypes.func,
};

export default PublicAccessCTA;
